var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16639_159353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1915 31.9998C33.0994 31.9998 40.3206 24.8364 40.3206 15.9999C40.3206 7.1634 33.0994 0 24.1915 0C15.2837 0 8.0625 7.1634 8.0625 15.9999C8.0625 24.8364 15.2837 31.9998 24.1915 31.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16639_159353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3453 13.5876L25.27 13.8502C25.0409 14.4878 24.6167 15.0404 24.0554 15.4326C23.494 15.8247 22.8229 16.0372 22.1338 16.041H19.374C19.1534 16.044 18.943 16.1325 18.7886 16.2871C18.711 16.36 18.6501 16.448 18.6097 16.5456C18.5694 16.6432 18.5505 16.748 18.5544 16.8533C18.5575 17.0657 18.6444 17.2686 18.7969 17.4194L25.7384 23.8276C25.8939 23.9731 26.1006 24.0542 26.3154 24.0542C26.5303 24.0542 26.737 23.9731 26.8925 23.8276L26.9845 23.7127C27.0854 23.5552 27.1288 23.3687 27.1076 23.1839C27.0863 22.999 27.0016 22.8267 26.8674 22.6953L21.4397 17.7066H22.3931C23.4401 17.6586 24.4442 17.2842 25.2594 16.6379C26.0746 15.9916 26.6584 15.107 26.926 14.1128L27.0263 13.6697H29.0168C29.2386 13.6697 29.4513 13.5833 29.6081 13.4294C29.765 13.2755 29.8531 13.0668 29.8531 12.8492V12.7343C29.8192 12.5417 29.7164 12.3672 29.563 12.2424C29.4097 12.1175 29.216 12.0505 29.0168 12.0533H27.018L26.9678 11.7989C26.817 11.1527 26.5323 10.5439 26.1314 10.0102L25.8806 9.68203H26.2736H29.0335C29.2553 9.68203 29.468 9.59558 29.6248 9.44171C29.7817 9.28783 29.8698 9.07914 29.8698 8.86152C29.8698 8.64391 29.7817 8.43521 29.6248 8.28134C29.468 8.12746 29.2553 8.04102 29.0335 8.04102H19.3656C19.1438 8.04102 18.9311 8.12746 18.7743 8.28134C18.6174 8.43521 18.5293 8.64391 18.5293 8.86152C18.5293 9.07914 18.6174 9.28783 18.7743 9.44171C18.9311 9.59558 19.1438 9.68203 19.3656 9.68203H22.3931C23.0308 9.72867 23.6414 9.95363 24.1528 10.3303C24.6641 10.7069 25.0548 11.2194 25.2784 11.8071L25.3788 12.0779H19.3823C19.1605 12.0779 18.9478 12.1644 18.791 12.3182C18.6341 12.4721 18.546 12.6808 18.546 12.8984V13.0215C18.5816 13.2126 18.6853 13.3852 18.8384 13.5084C18.9916 13.6316 19.1843 13.6975 19.3823 13.6943L25.3453 13.5876Z",
    fill: "#13458C"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_16639_159353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9994 6.08625C47.5829 5.44539 45.8132 2.40744 46.4553 0.00887353L46.4575 0.000246492C46.4571 0.00161844 46.4566 0.0030175 46.4563 0.00443676C46.4564 0.00296007 46.4564 0.00147669 46.4563 0L46.4541 0.00838055C45.8018 2.40423 42.7388 4.15651 40.3223 3.51416C42.7417 4.15725 44.5127 7.20013 43.8644 9.60017C44.5127 7.20013 47.5804 5.44341 49.9997 6.0865L49.9994 6.08625Z",
    fill: "#FAB73B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_16639_159353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96835 29.3768C6.00211 28.6903 4.72852 26.0534 5.41735 24.1014L5.41977 24.0944C5.41927 24.0955 5.41883 24.0966 5.41846 24.0978C5.41865 24.0965 5.41875 24.0953 5.41875 24.0941L5.41635 24.1009C4.71923 26.05 2.0608 27.3107 0.0946545 26.623C2.06323 27.3115 3.33753 29.9526 2.64345 31.9054C3.33753 29.9526 6.00017 28.6885 7.96854 29.377L7.96835 29.3768Z",
    fill: "#FAB73B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16639_159353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.2581,
    height: 31.9998,
    fill: "white",
    transform: "translate(8.0625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16639_159353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2903,
    height: 15.9999,
    fill: "white",
    transform: "translate(18.5469 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_16639_159353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.67742,
    height: 9.59994,
    fill: "white",
    transform: "translate(40.3223)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_16639_159353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.06452,
    height: 8.00015,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.6aa3b48deb594fd41300417029b95e47.svg";
export { ForwardRef as ReactComponent };